import Vue from 'vue'
import JsonApiObject from '@/_models/JsonApi'

import { query } from '@/_type/vbit-api'

export default class Permission extends JsonApiObject {
    public constructor(data: any, included?) {
        super(data, included)
    }

    get module(): string {
        return this._id ? this._id.split('.')[0] : ''
    }

    get name() {
        return this._id
    }

    get included() {
        return this._relationships['included']
            ? this._relationships['included'].map((permission) => permission._id)
            : []
    }

    get isProjectLevel() {
        return this['projectLevel']
    }

    get isContractorLevel() {
        return this['contractorLevel']
    }

    static async getAllPermissions() {
        let query: query = {
            include: ['included'],
        }

        let res = await Vue.prototype.$vbit.get('authorization', 'permissions', query)
        res.data = res.data.filter((permission) => !permission.attributes.isSystemPermission)
        let permissions = res.data.map((permission) => new Permission(permission, res.included))

        return permissions
    }
}
